import script from "./acPagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./acPagination.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__